<h1 class="visually-hidden">{{ 'dashboard.dashboard' | transloco }}</h1>
<div>
  <!-- Main container -->
  <div>
    <div class="flex-center-container">
      <span class="hyperlink" role="button" tabindex="0" [matMenuTriggerFor]="menu">
        {{ 'dashboard.displayValue' | transloco: { name: _displayName } }}
      </span>

      <mat-menu #menu="matMenu" class="centered-menu">
        <button mat-menu-item (click)="toggleVisiblity('', 'ALL')">
          {{ 'dashboard.all' | transloco }}
        </button>
        <button mat-menu-item (click)="toggleVisiblity('MyFiles', 'My Files Only')">
          {{ 'dashboard.myFilesOnly' | transloco }}
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item class="dropdown-header" disabled>
          {{ 'dashboard.byGroup' | transloco }}
        </button>
        <mat-divider></mat-divider>
        @for (option of _userGroups; track option) {
          <button mat-menu-item
            (click)="toggleVisiblity(option.value, option.label)">
            {{ option.label }}
          </button>
        }
      </mat-menu>
    </div>
    <!-- <div class="flex-container">
    <mat-form-field class="link-select" appearance="fill">
      <mat-label>File Visibility</mat-label>
      <mat-select [(ngModel)]="this._userGroupID" placeholder="User Group" (ngModelChange)="populateDashboard()">
        <mat-option [value]="''">ALL</mat-option>
        <mat-option [value]="'MyFiles'">My Files Only</mat-option>
        <mat-option disabled>--- By Group ---</mat-option>
        <mat-option *ngFor="let option of _userGroups" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->

  <div class="flex-container-stretch">
    <!-- Draft orders widget -->
    <div class="flex-item">
      <div class="padding grows-to-fill">
        <app-draft-order-list class="grows-to-fill" [data]="this._draftOrders"
        [total]="this._totalDraftOrders" [loading]="this._loading"></app-draft-order-list>
      </div>
    </div>
    <!-- End of pending orders widget-->

    <!-- Pending orders widget -->
    <div class="flex-item">
      <div class="padding-top-bottom grows-to-fill">
        <app-pending-order-list class="grows-to-fill" [data]="this._pendingOrders"
        [total]="this._totalPendingOrders" [loading]="this._loading"></app-pending-order-list>
      </div>
    </div>
    <!-- End of pending orders widget-->

    <!-- Invalid orders widget -->
    <div class="flex-item">
      <div class="padding grows-to-fill">
        <app-invalid-order-list class="grows-to-fill" [data]="this._invalidOrders"
        [total]="this._totalInvalidOrders" [loading]="this._loading"></app-invalid-order-list>
      </div>
    </div>
    <!-- End of pending orders widget-->
  </div>

  <div class="flex-container">
    <!-- Pending orders widget -->
    <div class="flex-item">
      <div class="padding">
        <app-complete-order-list [data]="this._completeOrders" [total]="this._totalCompleteOrders"
        [loading]="this._loading"></app-complete-order-list>
      </div>
    </div>
    <!-- End of pending orders widget-->
  </div>
</div>
<!-- End of main container -->

<!-- Spinner (replaces everything and waits until all requests have completed to show anything) -->
@if (_loading) {
  <div class="loading-spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<!-- End of spinner -->
</div>